import { getIsPlainObject } from '@creditinfo-ui/utils';
import { arrayEach, objectEach } from 'fast-loops';

// source: https://github.com/robinweser/fela/blob/master/packages/fela-plugin-multiple-selectors/src/index.js
// with added capability to handle array values (used in `extend`)
const multipleSelectorsPlugin = style => {
	objectEach(style, (value, property) => {
		if (getIsPlainObject(value)) {
			const resolvedValue = multipleSelectorsPlugin(value);

			const selectors = property.split(',');

			if (selectors.length > 1) {
				arrayEach(selectors, selector => {
					const key = selector.trim();

					// merge styles with base styles
					const baseStyle = style[key] || {};
					style[key] = {
						...baseStyle,
						...resolvedValue,
					};
				});

				delete style[property];
			}
		} else if (Array.isArray(value)) {
			value.map(multipleSelectorsPlugin);
		} else {
			style[property] = value;
		}
	});

	return style;
};

export const makeMultipleSelectorsPlugin = () => multipleSelectorsPlugin;
